import React from 'react';
import { isAuthenticated } from '../../services/Authentification/authentification';
import HeaderAuthenticated from './HeaderAuthenticated';
import HeaderStatique from './HeaderStatique';

const IHeader: React.FC = () => {
  return isAuthenticated() ? <HeaderAuthenticated /> : <HeaderStatique />;
};

export default IHeader;
